import {
    UPDATE_TABLE_CONFIG_REQUEST,
    updateTableConfigSuccess,
    updateTableConfigFailure,
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { message } from "antd";

export function updateTableConfigEpic(action$, store$, { TableRepository }) {
    return action$.pipe(
        ofType(UPDATE_TABLE_CONFIG_REQUEST),
        mergeMap( action => from(TableRepository.updateTableConfig( action.payload.tableConfig ))
            .pipe(
                mergeMap( tableEntry => {
                    message.success('Konfiguration wurde erfolgreich gespeichert.');
                    return from ([
                        updateTableConfigSuccess(tableEntry),
                    ]);
                }),
                catchError( error => {
                    return from([
                        updateTableConfigFailure(error),
                    ])
                })
            )
        ),
    );
}
